import {
  Typography,
  Paper,
  CardHeader,
  IconAvatar,
  AssignmentReturnOutlinedIcon,
} from '@occc/ui-design-system';
import { Switches } from '@occc-app/design-system';

type ReturnableProps = {
  disabled?: boolean;
};

export const Returnable = ({ disabled = false }: ReturnableProps) => (
  <Paper>
    <CardHeader
      title={<Typography variant='subtitle1'>Offer is Returnable</Typography>}
      subheader={
        <Typography variant='body2' color='textSecondary'>
          Members can choose to return this offer
        </Typography>
      }
      action={<Switches name='isOfferReturnable' data={{ disabled }} />}
      avatar={<IconAvatar Icon={AssignmentReturnOutlinedIcon} />}
      sx={{ py: 2, px: 3 }}
    />
  </Paper>
);
